export default __webpack_public_path__ + "static/media/exclamation.fec8f83a.svg";